// extracted by mini-css-extract-plugin
export default {"container":"GQ-z","darkBackground":"HQ-z","whiteBackground":"IQ-z","headerButton":"JQ-z","calloutHeading":"KQ-z","calloutSubHeading":"LQ-z"};